export default {"src":"/_next/static/media/banzai_icon_rgb_black.042b6dea.svg","height":203,"width":203,"blurWidth":0,"blurHeight":0};